import { useTranslation } from "react-i18next";

import { getDiffInDays } from "../../../helpers/diffInDays";

export function TimeComponent({ date, transKey }) {
	const { t } = useTranslation();

	const diffInDays = getDiffInDays(date);

	if (diffInDays < 0) {
		return t(`${transKey}.expired`);
	}

	if (diffInDays === 0) {
		return t(`${transKey}.lastDay`);
	}

	if (diffInDays === 1) {
		return t(`${transKey}.singular`, { days: diffInDays });
	}

	return t(`${transKey}.plural`, { days: diffInDays });
}
